'use client'

import { useState } from 'react'

import { ButtonDefault } from '@/components/common/Button'
import { ComboPreview } from '@/components/common/ComboPreview'
import { ErrorBlock } from '@/components/common/ErrorBlock'
import { NoResults } from '@/components/common/NoResults'
import { Subheader } from '@/components/common/Subheader'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { usePage } from '@/components/providers/PageProvider'
import { COLOR_ID_LABELS } from '@/defs/mtg'
import { fetchMoreCombos } from '@/utils/apiUtil'

import styles from './Combos.module.scss'

export const Combos = () => {
  const { page } = usePage()
  const [loading, setLoading] = useState(false)
  const [more, setMore] = useState(page?.combosList?.more)
  const colorId = page?.route?.section === 'combos' ? page.route.colorId : undefined
  const [combos, setCombos] = useState(page?.combosList?.combos || [])

  const onClick = () => {
    if (!more) return
    setLoading(true)
    void (async () => {
      const response = await fetchMoreCombos({ more, route: page?.route }).catch((e) => {
        console.error(e)
      })
      if (response) {
        setCombos((prev) => [...prev, ...response.combos])
        setMore(response.more)
      }
      setLoading(false)
    })()
  }

  if (!page?.combosList) return <ErrorBlock />

  const { icon, label: colorLabel } = colorId ? COLOR_ID_LABELS[colorId] : { icon: 'cards' as const }

  return (
    <section className={styles.container}>
      <Subheader>
        <IconWithLabel iconBefore={icon}>{colorLabel} Combos</IconWithLabel>
      </Subheader>
      {combos.length ? (
        <ul className={styles.combosList}>
          {combos.map((combo, i) => (
            <li key={i}>
              <ComboPreview combo={combo} />
            </li>
          ))}
        </ul>
      ) : (
        <NoResults size='lg' />
      )}
      {more && (
        <div className={styles.more}>
          <ButtonDefault disabled={loading} loading={loading} onClick={onClick} size='lg'>
            Load More
          </ButtonDefault>
        </div>
      )}
    </section>
  )
}
